/**
 * Dashboard aggregate hook (F10).
 *
 * Lives in `lib/` because two features consume it — the dashboard screen and
 * the analytics screen, which derives funnel conversion from the same counts.
 * The request itself is in `dashboard.api` so a test can stub it (see the note
 * there).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md tasks 7.16, 7.19, §3.1
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { Dashboard } from '@nexus/contracts';

import * as dashboardApi from './dashboard.api';
import { queryKeys } from './query-keys';

export function useDashboard(): UseQueryResult<Dashboard> {
  return useQuery({
    queryKey: queryKeys.dashboard.all,
    queryFn: () => dashboardApi.getDashboard(),
  });
}
